import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useStoredListLimit } from '../-useStoredListLimit';

const PermissionsIndexRedirect = () => {
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { metaSiteId } = Route.useParams();
  const limit = useStoredListLimit();

  useEffect(() => {
    navigate({
      to: '/administration/meta-sites/$metaSiteId/permissions/users/$page/$limit',
      params: { metaSiteId, page: '1', limit: String(limit) },
    });
  }, [limit, metaSiteId, navigate]);

  return null;
};

export const Route = createFileRoute('/_secured/administration/meta-sites/$metaSiteId/permissions/')({
  component: PermissionsIndexRedirect,
});
